/**
 * Pre-compiled localized messages for RangeCalendar component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import rangeCalendarMessages_en from "./intl/en";
import rangeCalendarMessages_de from "./intl/de";
import rangeCalendarMessages_es from "./intl/es";
import rangeCalendarMessages_fr from "./intl/fr-FR";
import rangeCalendarMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const rangeCalendarMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(rangeCalendarMessages_en),
  de: normalizeMessages(rangeCalendarMessages_de),
  es: normalizeMessages(rangeCalendarMessages_es),
  "fr-FR": normalizeMessages(rangeCalendarMessages_fr),
  "pt-BR": normalizeMessages(rangeCalendarMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for RangeCalendar component
 */
export type RangeCalendarMessageKey =
  | "nextMonth"
  | "nextYear"
  | "previousMonth"
  | "previousYear";
